<template>
  <div class="refer-block" v-if="msg.parentID && msg.replyQuote" >
    <span v-if="msg" @click="$emit('view-reply', { msg })"><b>Replying to:</b> {{ msg.replyQuote }}</span>
    <div @click="$emit('view-reply', { msg })" v-if="imgURL" class="preview-box" :style="{ backgroundImage: `url(${imgURL})` }"></div>
    <!-- <img :src="imgURL" v-if="imgURL" class="image-reply" alt=""> -->
  </div>
</template>

<script>
export default {
  props: {
    msgs: {},
    msg: {}
  },
  data () {
    return {
      parentMsg: false,
      imgURL: false
    }
  },
  mounted () {
    if (this.msgs && this.msg && this.msg.parentID) {
      let parentMsg = this.msgs.find(m => m._id === this.msg.parentID)
      if (parentMsg && parentMsg.imgURL) {
        this.parentMsg = parentMsg
        this.imgURL = parentMsg.imgURL
      }
    }
  }
}
</script>

<style>
  .refer-block{
    display: flex;
    justify-content: space-between;
    background-color: rgba(232, 232, 232, 0.87);
    border-radius: 5px;
    text-align: left;
    padding: 10px;
  }
  .refer-block span{
    border-left: blue solid 3px;
    padding-left: 10px;
  }
  .preview-box{
    width: 40px;
    height: 40px;
    background-size: cover;
  }
</style>
